import React from 'react';
import ReactDiffViewer from 'react-diff-viewer-continued';

// DiffViewer component
export default class DiffViewer extends React.Component {

     // Constructor 
     constructor(props) {
        super(props);
        this.state= {
        };
    };
    render(){
               
        try {
            return(true) ? (
                <ReactDiffViewer oldValue={this.props.leftText} newValue={this.props.rightText} splitView={true} />
            ):"";
        } catch (e){
            console.log(e);
            return "";
        }
    }

}
